import { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import DialogTitle from '@mui/material/DialogTitle';
import { FormControlWrapperBox } from './AttendanceDialog.styled';
import { putStudentTag } from './services/attendanceApis';
import StudentTagSwitch from './StudentTagSwitch';
import { attendanceTags } from './common/constants';
import { getSnackBar, getButtonSpinner } from 'utils/commonUtils';
import { displaySnackbar } from 'components/snackbar/store/SnackbarSlice';
import { useDispatch } from 'react-redux';
import { useNotification } from 'utils/commonUtils';

const StudentTagEditDialog = (props) => {
  const dispatch = useDispatch();
  const { handleErrorResponse, NotificationPopup } = useNotification();
  const { id, field, row, api, setIsStudentTagBeingEdited, getTableData } =
    props;
  const attendanceRow = { ...row };
  const selectedTags =
    attendanceRow?.studentData?.tags || attendanceRow?.tags || [];
  const [open, setOpen] = useState(true);
  const [changeTag, setChangeTag] = useState(false);
  const [loadingButton, setLoadingButton] = useState(false);
  const [tags, setTags] = useState(selectedTags || []);

  const handleClose = () => {
    api.setCellMode(id, field, 'view');
    setChangeTag(false);
    setOpen(false);
  };

  const handlePostProcess = async () => {
    setOpen(false);
    api.setCellMode(id, field, 'view');
    setIsStudentTagBeingEdited(false);
  };

  const handleSave = async () => {
    try {
      const message = 'Successfully the Student Tag is saved';
      const snackBar = getSnackBar(message);
      setLoadingButton(true);
      setIsStudentTagBeingEdited(true);
      setChangeTag(false);
      const { semester, studentId } = row;
      const postParams = {
        semester,
        tags: [...new Set(tags)],
      };
      const queryStringParam = {
        studentId,
      };
      await putStudentTag(postParams, queryStringParam);
      await handlePostProcess(postParams);
      getTableData();
      setLoadingButton(false);
      dispatch(displaySnackbar(snackBar));
    } catch (error) {
      setLoadingButton(false);
      setChangeTag(true);
      handleErrorResponse(error?.response?.data?.message);
    }
  };

  const disableButton = changeTag === true ? false : true;

  return (
    <>
      <Dialog open={open} onClose={handleClose} maxWidth={'sm'}>
        <DialogTitle>Student Tag</DialogTitle>
        <FormControlWrapperBox>
          {attendanceTags?.map(({ key, value }) => (
            <StudentTagSwitch
              key={key}
              tagKey={key}
              tagValue={value}
              setTags={setTags}
              selectedTags={selectedTags}
              setChangeTag={setChangeTag}
            />
          ))}

          <DialogActions>
            <Button onClick={handleClose}>Cancel</Button>
            {getButtonSpinner(loadingButton, handleSave, 'save', disableButton)}
          </DialogActions>
        </FormControlWrapperBox>
      </Dialog>
      <NotificationPopup />
    </>
  );
};

export const renderStudentTagEditDialog = (
  params,
  setIsStudentTagBeingEdited,
  getTableData
) => {
  return (
    <StudentTagEditDialog
      {...params}
      setIsStudentTagBeingEdited={setIsStudentTagBeingEdited}
      getTableData={getTableData}
    />
  );
};
